'use client';
import { useEffect, useState } from 'react';

export interface PreferenceToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => Promise<boolean | void>;
  onSaved?: (enabled: boolean) => void;
  label: string;
  onError?: (message: string) => void;
  className?: string;
}

export function PreferenceToggle({ enabled, onToggle, onSaved, label, onError, className }: PreferenceToggleProps) {
  const [on, setOn] = useState(enabled);
  const [pending, setPending] = useState(false);
  useEffect(() => setOn(enabled), [enabled]);

  async function flip() {
    const next = !on;
    setOn(next);
    setPending(true);
    try {
      const saved = await onToggle(next);
      const value = typeof saved === 'boolean' ? saved : next;
      setOn(value);
      onSaved?.(value);
    } catch (err) {
      setOn(!next);
      onError?.(err instanceof Error && err.message ? err.message : 'Your change wasn’t saved. Try again.');
    } finally {
      setPending(false);
    }
  }

  return (
    <button type="button" role="switch" aria-checked={on} aria-label={label} aria-busy={pending || undefined}
      disabled={pending} onClick={flip} className={`bay-pu-switch${className ? ` ${className}` : ''}`}>
      <span className="bay-pu-switch-track" data-on={on ? 'true' : 'false'}><span className="bay-pu-switch-knob" /></span>
    </button>
  );
}
